import { DefaultTheme } from 'styled-components';
import { theme } from '../../../config/theme';

export class Styling {
  public static getTheme = (): DefaultTheme => theme;
}
